module.exports = __webpack_public_path__ + "static/media/3D打印电子琴.fcf9cf81.png";